import React from 'react';
import { useEffect, useState } from 'react';
import Swp from '../../../lib/component/swp/swp';
import KeyWord from './keyWord/keyWord';
import Card2 from './card2/card';
import CardTitle from '../../../lib/component/cardTitle/cardTitle';
import Loading from '../../../lib/component/loading1/loading';
import { Link } from 'react-router-dom';

import originalApi from '../js/originalApi';
import { Section } from '../js/interface';
import statisticsApi from '../../../lib/statisticsApi';

export default () => {
  const [info, setInfo] = useState<Section[]>([]);
  const strSwpArr = ['bookListDetails', 'bookListDetails', 'bookListDetails', 'bookListDetails'];
  useEffect(() => {
    originalApi.getHomeApi(
      (res: any) => {
        setInfo([...res.sections]);
      },
      () => {}
    );
    statisticsApi.statisticsApi(4);
  }, []);

  function swpRender() {
    if (info.length) {
      return <Swp {...{ bdArr: info[0].boutique_data, strSwpArr: strSwpArr, tip: 'original' }}></Swp>;
    }
  }

  function cardRender() {
    if (info.length) {
      return info.map((item, index) => {
        if (index > 0 && index < info.length - 1) {
          return <Card2 {...{ title: item.category?.name, bookArr: item.boutique_data, button: '', fn: null }} key={index}></Card2>;
        }
      });
    } else {
      return <Loading></Loading>;
    }
  }

  return (
    <>
      {swpRender()}
      {info.length > 0 && <KeyWord {...{ keyWords: ['男频', '女频', '完结', '书单'] }}></KeyWord>}
      {cardRender()}
      {info.length > 0 && <CardTitle {...{ title: '书单', tip: '', fn: () => {} }}></CardTitle>}
      {info.length > 0 && (
        <Link
          to={`/booklist`}
          onClick={() => {
            statisticsApi.statisticsApi(85);
          }}
        >
          <button className="originalBtn">全部原创小说书单</button>
        </Link>
      )}
      <div style={{ height: '50px' }}></div>
    </>
  );
};
